module.exports = __webpack_public_path__ + "img/andrew-cutler.3b84a3ee.png";